import { render, staticRenderFns } from "./POSIcon.vue?vue&type=template&id=80310494&"
import script from "./POSIcon.vue?vue&type=script&lang=ts&"
export * from "./POSIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports